
<div class="content mt-2 mb-3">
  <app-datatable [dataSource]="deviceSource"
                [columns]="columns"
                [identifier]="'mdm'"
                [customActions]="customActions"
                [actionNew]="false"
                (showEvent)="show($event.valueOf())">
                  <app-empty-table [icon]="'devices'"
                    [emptyText]="'mdm.empty_text' | translate"
                    [buttonText]="'worker.pair' | translate"
                    (btnClick)="emptyButtonClick()">
                  </app-empty-table>
  </app-datatable>
  <app-error [error]="error"></app-error>
</div>
